import React, { FC } from 'react';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import { TimelineItemsList } from '@v2/pages/machines/modules/timeline/components/TimelineItemsList/TimelineItemsList';
import { NavigationProps } from '@interfaces/navigation';

import RunningBatch from '@v2/pages/machines/common/components/RunningBatch/RunningBatch';
import {
  MACHINES_PAGES_CONTAINER_STYLES,
  NOT_PANEL_VIEW_MODE_WIDTH,
  SCREEN_PADDING_HORIZONTAL_FOR_ITEM,
} from '../../../../../common/constants/base.constants';
import ColorWrapper from '@styles/colors';
import { scale } from '@components/frame';
import { connect, useSelector } from 'react-redux';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { ProductionBatchStatistics } from '@interfaces/search';
import { LoadSingleBatch } from '@interfaces/methods';
import { loadSingleBatch } from '@reducers/batch';
import { selectSelectedItem } from '@reducers/machines';
import { Machine } from '@interfaces/machines';
import { TourTarget } from '@components/tours';
import { WELCOME_TOUR_IDS } from '@components/tours/config/global/welcome/constants';

interface BatchGeneralProps extends NavigationProps {
  batch: ReducerEntityWithLoadingState<ProductionBatchStatistics | null>;
  batchLoadedTime: string;
  loadSingleBatch: LoadSingleBatch;
}

const BatchGeneralComponent: FC<BatchGeneralProps> = ({ lg, batchLoadedTime, batch, loadSingleBatch }) => {
  const selectedMachine: Machine = useSelector(selectSelectedItem);

  return (
    <MachinesProvider lg={lg} panelViewMode={false} onBack={() => {}} getList={(props) => <TimelineItemsList {...props} />} withDefaultComponent>
      <TourTarget tourId={WELCOME_TOUR_IDS.BATCH_DETAILS} style={MACHINES_PAGES_CONTAINER_STYLES}>
        <RunningBatch
          withImages={true}
          loadBatch={loadSingleBatch}
          batchLoading={!batch?.wasLoaded}
          batchLoadedTime={batchLoadedTime}
          maxDetailsWidth={scale(NOT_PANEL_VIEW_MODE_WIDTH - SCREEN_PADDING_HORIZONTAL_FOR_ITEM * 2)} // taking into account shadow offset
          noMachine={false}
          currentBatchId={selectedMachine?.machineStatus?.productionBatchId}
          bg="Background/Light/Field"
        />
      </TourTarget>
    </MachinesProvider>
  );
};

const BatchGeneral = connect(({ batch: { batchLoadedTime, batch } }) => ({ batchLoadedTime, batch }), {
  loadSingleBatch,
})(ColorWrapper(BatchGeneralComponent));

export { BatchGeneral };
